import { buildApiUrl } from './apiUrl';

export function describeSubmitFiles(files) {
	const list = Array.isArray(files) ? files : [];
	const total = list.reduce((sum, file) => sum + (Number(file.size) || 0), 0);
	const names = list
		.map((file) => `${file.name || 'fil'}:${Number(file.size) || 0}`)
		.join(', ');
	return { count: list.length, total, names };
}

export function createSubmitFlow(submissionId) {
	const t0 = Date.now();
	const events = [];
	let lastPctLogged = -1;

	function mark(event, detail = '') {
		const elapsedMs = Date.now() - t0;
		console.log(
			`[submit-flyt] ${event} +${elapsedMs}ms${detail ? ` ${detail}` : ''}`
		);
		events.push({ event, elapsedMs, detail });
		return elapsedMs;
	}

	function ping(event, detail = '') {
		const elapsedMs = mark(event, detail);
		fetch(buildApiUrl('form/submit-trace'), {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				submissionId,
				event,
				elapsedMs,
				detail: String(detail).slice(0, 500),
				clientT0: t0,
			}),
		}).catch(() => {});
		return elapsedMs;
	}

	function uploadProgress(loaded, total) {
		if (!total) {
			return;
		}
		const pct = Math.min(100, Math.max(0, Math.round((loaded / total) * 100)));
		const bucket = pct === 100 ? 100 : Math.floor(pct / 10) * 10;
		if (bucket === lastPctLogged) {
			return;
		}
		lastPctLogged = bucket;
		mark(`nettleser sendt ${bucket} %`, `${loaded} av ${total} bytes`);
	}

	return { t0, mark, ping, uploadProgress, events };
}
